<ng-template #displayTemplateRef
             let-cellData
             let-rowData="rowData">
  @if (checkHasValue(cellData)) {
    @if (!isClickable(rowData)) {
      <span [innerHTML]="getCellValue(cellData) | safeMessage:'html'">
      </span>
    } @else {
      @if (external) {
        @if (hasIcon) {
          <a [href]="linkExpr(rowData, cellData)"
             target="_blank">
            <i class="fas fa-link mr-2"></i>
          </a>
        }
        <a scOverflowTooltip
           [href]="linkExpr(rowData, cellData)"
           target="_blank"
           [innerHTML]="getCellValue(cellData) | safeMessage:'html'">
        </a>
      } @else {
        @if (hasIcon) {
          <a [routerLink]="linkExpr(rowData, cellData)">
            <i class="fas fa-link mr-2"></i>
          </a>
        }
        <a scOverflowTooltip
           [routerLink]="linkExpr(rowData, cellData)"
           [state]="getFilterParams(rowData)"
           [innerHTML]="getCellValue(cellData) | safeMessage:'html'">
        </a>
      }
    }
  }
</ng-template>